import { useReportingContext } from 'modules/iterableGoals/contexts';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { localizeCurrencyValue } from 'utils/i18nHelpers';

import { localize } from 'utils/numberHelpers';
import {
  HeaderContainer,
  OverallMetricsLabel,
  OverallMetricsSubLabel,
  SubLabel,
  SubLabelValue,
  TitleText,
} from './Styled';

type OverallStatsHeaderProps = {
  totalReportedValue: number;
  totalSends: number;
};

export const OverallStatsHeader = ({ totalReportedValue, totalSends }: OverallStatsHeaderProps) => {
  const { t } = useGoalsTranslations();
  const { isRevenue, getReportingTranslation } = useReportingContext();
  const totalValue = isRevenue
    ? localizeCurrencyValue(totalReportedValue)
    : localize(totalReportedValue);

  return (
    <HeaderContainer>
      <TitleText>{getReportingTranslation('labels.goalContributionsByMedium.title')}</TitleText>
      <OverallMetricsLabel>{totalValue}</OverallMetricsLabel>
      <OverallMetricsSubLabel>
        <SubLabel>{t('labels.goalContributionsByMedium.subLabel')}</SubLabel>
        <SubLabelValue>{localize(totalSends)}</SubLabelValue>
      </OverallMetricsSubLabel>
    </HeaderContainer>
  );
};
